export const DATA_ATTRIBUTE = 'data-playback-stats';
const applyStyles = (element, style) => {
    Object.entries(style).forEach(([property, value]) => {
        const cssProperty = property.replace(/([A-Z])/g, '-$1').toLowerCase();
        const cssValue = typeof value === 'number' ? `${value}px` : value;
        element.style.setProperty(cssProperty, cssValue);
    });
};
// eslint-disable-next-line func-style, @typescript-eslint/no-explicit-any
export function createElement(tag, props, ...children) {
    const el = document.createElement(tag);
    for (const [attribute, value] of Object.entries(props || {})) {
        if (attribute === 'style' && typeof value === 'object') {
            applyStyles(el, value);
        }
        if (attribute === 'key') {
            el.setAttribute(DATA_ATTRIBUTE, value);
        }
    }
    for (const child of children.flat()) {
        el.append(child instanceof Node ? child : document.createTextNode(child));
    }
    return el;
}
